import React from "react";
import { Avatar } from "../../../../components/Avatar/Avatar";
import { useNavigate } from "react-router-dom";
import { navigateToStaffSalaryDetails } from "../../../../Navigation/Navigation";

const SalaryTable = ({ allStaffSalary, page, pageLimit, selectedMonth }) => {
  const navigate = useNavigate();

  return (
    <table id="datable_1" className="table table-bordered">
      <thead>
        <tr className="text-center">
          <th>No.</th>
          <th style={{ textAlign: "left" }}>Employee</th>
          <th>Payment Type</th>
          <th>Settlement Date</th>
          <th>Salary Amount</th>
        </tr>
      </thead>
      <tbody>
        {allStaffSalary?.map((salary, index) => {
          return (
            <tr className="text-center">
              <td>{(page - 1) * pageLimit + (index + 1)} .</td>
              <td
                style={{ textAlign: "left" }}
                onClick={() =>
                  navigate(
                    navigateToStaffSalaryDetails({
                      id: salary?.staff?.employeeId?._id,
                      monthname: selectedMonth,
                    }),
                    {
                      state: {
                        employeeName: salary?.staff?.employeeId?.name,
                        image: salary?.staff?.employeeId?.image,
                      },
                    }
                  )
                }
              >
                <div className="d-flex align-items-center gap-2">
                  <Avatar
                    name={salary?.staff?.employeeId?.name}
                    count={1}
                    image={salary?.staff?.employeeId?.image}
                    size="xs"
                    color="primary"
                  />
                  <div className="w-200p">
                    <p className="text-dark text-truncate text-nowrap">
                      {salary?.staff?.employeeId?.name}
                    </p>
                    {salary?.staff?.employeeId?.permissions?.length === 0 && (
                      <span className="badge badge-sm badge-red">Removed</span>
                    )}
                  </div>
                </div>
              </td>
              <td style={{ textTransform: "capitalize" }}>
                {salary?.staff?.paymentType}
              </td>
              <td>
                {salary?.staff?.settlementDate
                  ? `${salary?.staff?.settlementDate} of every month`
                  : "No settlement date"}
              </td>
              <td> ₹ {salary?.staff?.salary}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default SalaryTable;
